import React from 'react';
import { Box } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../../components/admin';
import { useHydrantMapaQuery } from '../../../api/JsdhNotifikaceService/service/HydrantBodMutations';
import { HydrantStav } from '../../../api/JsdhNotifikaceService/generated/models/HydrantBod';

const BARVA: Record<HydrantStav, string> = {
  OK: '#2e7d32', BLIZI_KONTROLA: '#ed6c02', ZAVADA: '#d32f2f', NEZKONTROLOVAN: '#616161',
};

const makeIkona = (stav: HydrantStav) =>
  L.divIcon({
    className: 'hydrant-marker',
    html: `<div style="width:18px;height:18px;border-radius:50%;background:${BARVA[stav]};border:2px solid #fff;box-shadow:0 0 3px rgba(0,0,0,.5)"></div>`,
    iconSize: [18, 18], iconAnchor: [9, 9],
  });

const IKONY: Record<HydrantStav, L.DivIcon> = {
  OK: makeIkona('OK'),
  BLIZI_KONTROLA: makeIkona('BLIZI_KONTROLA'),
  ZAVADA: makeIkona('ZAVADA'),
  NEZKONTROLOVAN: makeIkona('NEZKONTROLOVAN'),
};

const ikona = (stav: HydrantStav): L.DivIcon => IKONY[stav] ?? makeIkona('NEZKONTROLOVAN');

const HydrantMapaPage: React.FC = () => {
  const { data: body } = useHydrantMapaQuery();
  const navigate = useNavigate();
  const stred: [number, number] = body && body.length > 0 && body[0].lat && body[0].lng
    ? [body[0].lat, body[0].lng] : [49.8, 15.5];

  return (
    <Box>
      <PageHeader title="Mapa hydrantů" subtitle="Barevný stav dle poslední kontroly" />
      <Box sx={{ height: '70vh', mt: 2 }}>
        <MapContainer center={stred} zoom={body && body.length ? 14 : 7} style={{ height: '100%', width: '100%' }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; OpenStreetMap' />
          {(body ?? []).filter((h) => h.lat != null && h.lng != null).map((h) => (
            <Marker key={h.id} position={[h.lat!, h.lng!]} icon={ikona(h.stav)}>
              <Popup>
                <strong>{h.oznaceni}</strong><br />
                Stav: {h.stav}<br />
                <button onClick={() => navigate(`/admin/hydranty-evidence/${h.id}`)}>Detail / kontrola</button>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </Box>
    </Box>
  );
};

export default HydrantMapaPage;
